<template>
    <ubi-panel v-loading="loading">
      <el-dialog class="confirmationAnnulation" width="20%" :title="$t('posts.edit.visite.confirmationAnnulationTitle')" :visible.sync="confirmationAnnulation">
        <span>{{ $t('posts.edit.visite.confirmationAnnulationText') }}</span><br/><br/>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visiteAnnulee = {}; confirmationAnnulation = false">{{ $t('posts.edit.visite.annuler') }}</el-button>
          <el-button type="primary" @click="annulerVisite(); confirmationAnnulation = false">{{ $t('posts.edit.visite.confirmer') }}</el-button>
        </span>
      </el-dialog>
        <el-container>
          <el-aside width="25%">
            <h3>{{ $t("posts.edit.visite.title") }}</h3>
            <p class="text-justify">{{ $t("posts.edit.visite.description") }}</p>
          </el-aside>
          <el-row>
            <el-col>
              <el-aside>
                <h4>{{ $t("posts.edit.visite.lieu_visite") }}</h4>
                <p class="text-justify">
                  {{ post.numero_voie }} {{ post.nom_voie }} {{ post.code_postal }} {{ post.ville }}
                  <span v-if="post.adresse2">
                    <br />
                    {{ post.adresse2 }}
                  </span>
                </p>
              </el-aside>
            </el-col>
            <el-col>
              <el-form-item :label="$t('posts.edit.visite.commentaire')">
                <el-input v-model="visite_commentaire" type="textarea" :rows="5" @change="setVisiteValue('visite_commentaire', visite_commentaire)" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-container>
        <el-container>
          <el-row>
            <el-table :data="visites">
              <el-table-column width="170px" align="center">
                <template v-slot="{ row: visite }">
                  {{ $t("posts.edit.visite.visite") }} {{ visite.ordre }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('posts.edit.visite.dateDebut')" width="150px" align="center">
                  <template v-slot="{ row: visite }">
                    {{ visite.dateVisite }}
                  </template>
              </el-table-column>
              <el-table-column :label="$t('posts.edit.visite.horaire')" width="150px" align="center">
                <template v-slot="{ row: visite }">
                  {{ visite.horaireVisite }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('posts.edit.visite.nombre_candidats_max')" width="145px" align="center">
                <template v-slot="{ row: visite }">
                  {{ visite.nbPersonne }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('posts.edit.visite.nombre_candidats_inscrits')" width="145px" align="center">
                <template v-slot="{ row: visite }">
                  {{ visite.nbInscrits }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('posts.edit.visite.status')" width="150px" align="center">
                <template v-slot="{ row: visite }">
                  {{ visite.status == 'ACTIF' ? $t('posts.edit.visite.statusActive') : $t('posts.edit.visite.statusInactive') }}
                </template>
              </el-table-column>
              <el-table-column width="100px" align="center">
                <template v-slot="{ row: visite }">
                  <el-button size="mini" @click="visiteAnnulee = visite; confirmationAnnulation = true" icon="trash" v-if="visite.status == 'ACTIF'" />
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-container>
      <table style="width: 1000px;">
        <tr>
          <td class="champSaisie">
            <el-form-item>
              {{ $t("posts.edit.visite.visite") }} {{ visites.length + 1 }}
            </el-form-item>
          </td>
          <td class="champSaisie">
            <el-form-item>
              <input type="date" v-model="newVisite.visite_dateVisite" style="width: 160px;" class="el-input__inner" prop="dateVisite" required />
            </el-form-item>
          </td>
          <td class="champSaisie">
            <el-form-item>
              <input type="time" step="900" v-model="newVisite.visite_horaireVisite" style="width: 160px;" class="el-input__inner" prop="horaireVisite" required />
            </el-form-item>
          </td>
          <td class="champSaisie">
            <el-form-item>
              <input type="number" v-model.number="newVisite.visite_nbPersonne" style="width: 160px;" class="el-input__inner" prop="nbPersonne" required />
            </el-form-item>
          </td>
          <td class="champSaisie">
            <el-form-item>
              <el-button type="success" @click="handleVisite">{{ $t("posts.edit.visite.saveVisite") }}</el-button>
            </el-form-item>
          </td>
          <td class="champSaisie">
          </td>
        </tr>
      </table>
    </ubi-panel>
</template>

<script>

import UbiPanel from '../../../../components/Panel'
import { getVisites, saveVisite } from '@/services/visites.js'
import moment from 'moment'
import Vue from 'vue'
import { getPostById } from '@/services/posts'
import { mapGetters } from 'vuex'

export default {
  name: 'PostFormVisite',
  components: { UbiPanel },
  props: ['post'],
  data () {
    return {
      visites: [],
      visite_duree_publication: 0,
      visite_commentaire: null,
      newVisite: {},
      loading: false,
      confirmationAnnulation: false,
      visiteAnnulee: {}
    }
  },
  computed: {
    ...mapGetters(['getSitimmoUser'])
  },
  beforeMount () {
    this.post.visite_dateVisite = null
    this.post.visite_horaireVisite = null
    this.post.visite_nbPersonne = null
    this.handleVisites()
  },
  methods: {
    async handleVisites () {
      this.loading = true
      let post = this.post
      if (!this.post.id && this.$route.params.id) {
        post = await getPostById(this.$route.params.id)
      }
      const filters = { post: post }
      const dataVisites = await getVisites(filters)
      if (dataVisites && dataVisites.items && dataVisites.items.length > 0) {
        let cpt = 1
        dataVisites.items.forEach((element) => {
          const dateDebut = new Date(element.dateDebut)
          element.dateVisite = moment.utc(dateDebut).format('DD/MM/YYYY')
          element.horaireVisite = moment.utc(dateDebut).format('HH:mm')
          element.ordre = cpt
          // Gestion des candidats inscrits (OUI)
          element.nbInscrits = 0
          element.candidats.forEach((candidat) => {
            if (candidat.status === 'OUI') {
              element.nbInscrits++
            }
          })

          this.visite_duree_publication = element.duree
          this.newVisite.visite_duree_publication = element.duree
          this.visite_commentaire = element.message
          this.newVisite.visite_commentaire = element.message
          this.newVisite.visite_id = element.id
          cpt += 1
        })
        this.visites = dataVisites.items
      }
      this.loading = false
    },
    async handleVisite () {
      const {
        visite_dateVisite,
        visite_horaireVisite,
        visite_nbPersonne,
        visite_duree_publication,
        visite_commentaire
      } = this.newVisite

      // 1. Vérification des champs obligatoires (retour anticipé)
      if (!visite_dateVisite || !visite_horaireVisite || !visite_nbPersonne) {
        this.$message.error(this.$t('posts.edit.visite.requiredFields'))
        return
      }

      const idSitimmoUser = this.getSitimmoUser.id
      this.loading = true

      try {
        // 2. Déclaration propre de l'objet
        const dataVisite = {
          annonceur: idSitimmoUser,
          refAnnonce: this.post.reference,
          duree: visite_duree_publication,
          message: visite_commentaire,
          dateDebut: `${visite_dateVisite} ${visite_horaireVisite}:00`,
          nbPersonne: visite_nbPersonne,
          status: 'ACTIF',
          dateVisite: visite_dateVisite,
          horaireVisite: visite_horaireVisite,
          ordre: this.visites.length + 1
        }

        // 3. Appel API
        const retour = await saveVisite(dataVisite)

        // 4. Mise à jour des données locales en cas de succès
        dataVisite.id = retour.data.id
        this.visites.push(dataVisite)
        this.newVisite = {}
      } catch (error) {
        // 5. Gestion de l'erreur API
        console.error('Erreur lors de la sauvegarde :', error)
        this.$message.error('Impossible de sauvegarder la visite.')
      } finally {
        // 6. S'exécute toujours, succès ou échec
        this.loading = false
      }
    },
    async annulerVisite () {
      if (this.visiteAnnulee) {
        this.loading = true
        this.visiteAnnulee.status = 'INACTIF'
        await saveVisite(this.visiteAnnulee)
        this.visiteAnnulee = {}
        this.loading = false
      }
    },
    setVisiteValue: function (champ, valeur) {
      Vue.set(this.newVisite, champ, valeur)
    }
  }
}
</script>

<style scoped>
  .champSaisie {
    width: 165px;
    text-align: center;
    padding: 12px 0;
    font-size: 14px
  }
</style>
